import React from 'react';

import ConfigContext from './ConfigContext';

export { ConfigProvider } from './ConfigContext';

export const useConfig = () => React.useContext(ConfigContext);
